module.exports = __webpack_public_path__ + "img/order_price.bf42dd0a.svg";